import { render, staticRenderFns } from "./main-topbar.vue?vue&type=template&id=287a6450&"
import script from "./main-topbar.vue?vue&type=script&lang=js&"
export * from "./main-topbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports